export const attemptLimitExceededMessage = () => {
  return `User blocked for over-trying, wait a few minutes and try again`;
};
